import { url } from '../request/index'

let ip = url
export const publicData = {

  //民族
  nation: [
    { label: '汉族', value: '1' },
    { label: '蒙古族', value: '2' },
    { label: '回族', value: '3' },
    { label: '藏族', value: '4' },
    { label: '维吾尔族', value: '5' },
    { label: '苗族', value: '6' },
    { label: '彝族', value: '7' },
    { label: '壮族', value: '8' },
    { label: '布依族', value: '9' },
    { label: '朝鲜族', value: '10' },
    { label: '满族', value: '11' },
    { label: '侗族', value: '12' },
    { label: '瑶族', value: '13' },
    { label: '白族', value: '14' },
    { label: '土家族', value: '15' },
    { label: '哈尼族', value: '16' },
    { label: '哈萨克族', value: '17' },
    { label: '傣族', value: '18' },
    { label: '黎族', value: '19' },
    { label: '傈傈族', value: '20' },
    { label: '佤族', value: '21' },
    { label: '畲族', value: '22' },
    { label: '高山族', value: '23' },
    { label: '拉祜族', value: '24' },
    { label: '水族', value: '25' },
    { label: '东乡族', value: '26' },
    { label: '纳西族', value: '27' },
    { label: '景颇族', value: '28' },
    { label: '柯尔克孜族', value: '29' },
    { label: '土族', value: '30' },
    { label: '达翰尔族', value: '31' },
    { label: '仫佬族', value: '32' },
    { label: '羌族', value: '33' },
    { label: '布朗族', value: '34' },
    { label: '撒拉族', value: '35' },
    { label: '毛南族', value: '36' },
    { label: '仡佬族', value: '37' },
    { label: '锡伯族', value: '38' },
    { label: '阿昌族', value: '39' },
    { label: '普米族', value: '40' },
    { label: '塔吉克族', value: '41' },
    { label: '怒族', value: '42' },
    { label: '乌孜别克族', value: '43' },
    { label: '俄罗斯族', value: '44' },
    { label: '鄂温克族', value: '45' },
    { label: '德昂族', value: '46' },
    { label: '保安族', value: '47' },
    { label: '裕固族', value: '48' },
    { label: '京族', value: '49' },
    { label: '塔塔尔族', value: '50' },
    { label: '独龙族', value: '51' },
    { label: '鄂伦春族', value: '52' },
    { label: '赫哲族', value: '53' },
    { label: '门巴族', value: '54' },
    { label: '珞巴族', value: '55' },
    { label: '基诺族', value: '56' },
    { label: '其它', value: '99' },
  ],
  //岗位类型
  gangweileixing: [
    { label: '计算机/通信类', value: '1' },
    { label: '市场营销类', value: '2' },
    { label: '模具/刀具/手版制作', value: '3' },
    { label: '物流/仓储类', value: '4' },
    { label: '财务/金融类', value: '5' },
    { label: '行政/人力资源类', value: '6' },
    { label: '教育/培训类', value: '7' },
    { label: '医疗/保健类', value: '8' },
    { label: '机关单位/学生类', value: '9' },
    { label: '技工/普工类', value: '10' },
    { label: '房产/物业类', value: '11' },
    { label: '服务/后勤类', value: '12' },
    { label: '建筑/装修/市政类', value: '13' },
    { label: '农林渔牧类', value: '14' },
    { label: '交通运输类', value: '15' },
    { label: '其它类', value: '16' },
    { label: '客服/技术支持', value: '17' },
    { label: '贸易/采购', value: '18' },
    { label: '经营管理', value: '19' },
    { label: '证券/期货/投资/银行', value: '20' },
    { label: '互联网/网络', value: '21' },
    { label: '机械', value: '22' },
    { label: '汽车/飞机/船舶/列车', value: '23' },
    { label: '电力/能源', value: '24' },
    { label: '电气', value: '25' },
    { label: '电子/半导体/电器/仪表', value: '26' },
    { label: '化工', value: '27' },
    { label: '艺术设计', value: '28' },
    { label: '影视/媒体', value: '29' },
    { label: '法律', value: '30' },
    { label: '翻译', value: '31' },
    { label: '咨询', value: '32' },
    { label: '环保', value: '33' },
    { label: '制药/医疗器械', value: '34' },
    { label: '美容/健身', value: '35' },
    { label: '学生/社工/科研', value: '36' },
  ],
  //文化程度
  wenHuaCD: [
    { label: '文盲或半文盲', value: '0' },
    { label: '普通高中', value: '1' },
    { label: '初中', value: '2' },
    { label: '技工学校', value: '3' },
    { label: '职业高中', value: '4' },
    { label: '中等专科', value: '5' },
    { label: '大学专科', value: '6' },
    { label: '大学本科', value: '7' },
    { label: '硕士研究生', value: '8' },
    { label: '博士研究生', value: '9' },
    { label: '小学', value: '10' },
    { label: '其它', value: '11' },
  ],
  wenHuaCD_: [
    { label: '高中及以下', value: '0' },
    { label: '中专', value: '1' },
    { label: '大专', value: '2' },
    { label: '本科', value: '3' },
    { label: '硕士', value: '4' },
    { label: '博士', value: '5' },
    { label: '其它', value: '6' },
  ],
  //是否
  options: [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
  ],
  //性别
  sex: [
    { label: '男', value: '1' },
    { label: '女', value: '0' },
  ],
  //性别要求
  sexyaoqiu: [
    { label: '不限', value: '2' },
    { label: '男', value: '1' },
    { label: '女', value: '0' },
  ],
  //有无
  options1: [
    { label: '有', value: '1' },
    { label: '无', value: '0' },
  ],
  //核实情况
  heShiQK: [
    { label: '未核实', value: '0' },
    { label: '已核实', value: '1' },
    { label: '联系不上', value: '2' },
  ],
  // 当前状态+人员状态
  dangQianZT: [
    { label: '正常劳动力', value: '-1' },
    { label: '正常贫困劳动力', value: '0' },
    { label: '暂时退出劳动力市场', value: '1' },
    { label: '上学', value: '2' },
    { label: '参军', value: '3' },
    { label: '暂时丧失劳动能力', value: '4' },
    { label: '服刑', value: '5' },
    { label: '死亡', value: '6' },
    { label: '永久丧失劳动力', value: '7' },
    { label: '已退出扶贫建档立卡系统', value: '8' },
  ],
  // 技能等级
  jiNengDJ: [
    { label: '高级技师', value: '0' },
    { label: '技师', value: '1' },
    { label: '高级', value: '2' },
    { label: '中级', value: '3' },
    { label: '初级', value: '4' },
  ],
  // 培训类别
  peiXunLB: [
    { label: '职业技能培训', value: '0' },
    { label: '创业培训', value: '1' },
  ],
  // 就业形式
  jiuYeXS: [
    { label: '单位就业', value: '0' },
    { label: '自主创业', value: '1' },
    { label: '灵活就业', value: '2' },
    { label: '农业合作社等新型经营主体', value: '3' },
    { label: '扶贫车间等载体', value: '4' },
    { label: '其它就业形式', value: '5' },
    { label: '人社部门开发公益性岗位', value: '6' },
    { label: '其它部门开发公益性岗位', value: '7' },
  ],
  // 未转移就业类型
  weiZhuanYiJY: [
    { label: '从未转移过', value: '0' },
    { label: '就业转失业', value: '1' }
  ],
  // 与户主关系
  yuhuzhuguanxi: ['户主', '配偶', '之子', '之女', '之父', '之母', '之孙子', '之孙女', '之儿媳', '之女婿', '之外孙子', '之外孙女', '之兄弟姐妹', '之祖父', '之祖母', '之公公', '之婆婆', '之岳父', '之岳母', '其它'],
  // 无就业意愿原因
  wuJiuYeYiYYYY: [
    { label: '务农', value: '0' },
    { label: '照顾家人', value: '1' },
    { label: '身体或精神状态不佳', value: '2' },
    { label: '主观意愿不强', value: '3' },
    { label: '其它', value: '4' }
  ],
  // 劳动技能 
  laoDongNL: [
    // { label: '无劳动力', value: '0' },
    { label: '普通劳动能力', value: '1' },
    { label: '技能劳动能力', value: '1' },
    // { label: '弱劳动力或半劳动力', value: '1' },
    // { label: '丧失劳动力', value: '1' },
  ],
  // 车间状态 
  chejianzhuangtai: [
    { label: '已认定', value: '0' },
    { label: '未认定', value: '1' },
  ],
  // 扶贫车间类型 
  fupinchejianleixing: [
    { label: '厂房型', value: '0' },
    { label: '居家型', value: '1' },
  ],
  //所属行业产业
  suoShuHangYeCY: [
    { label: '种植', value: '0' },
    { label: '养殖', value: '1' },
    { label: '技工', value: '2' },
    { label: '普工', value: '3' },
    { label: '家庭服务业', value: '4' },
    { label: '建筑/装修', value: '5' },
    { label: '环卫/市政维护', value: '6' },
    { label: '行政/管理', value: '7' },
    { label: '服务员/接待员/收银、导购员', value: '8' },
    { label: '其它', value: '9' },
  ],
  // 所属行业3g48
  suoshuhangye3g: ['不限','IT科技｜网络', '金融｜证券｜保险', '生产｜加工｜制造', '医药｜医院｜药业', '健身｜保健｜美容', '广告｜媒介｜营销', '房产｜物业｜建筑｜装饰', '电子｜通讯｜通信', '商场｜超市｜百货', '汽车｜物流｜运输', '食品｜快消｜零售', '中介｜咨询｜服务', '酒店｜餐饮｜娱乐', '教育｜培训', '其它'],
  // 公司性质
  gongsixz: ['内资企业', '外资企业', '合作企业', '事业机关', '合资企业', '其它'],
  // 注册资金：
  zhucezijin: ['10万元以下', '10万-50万', '50万-100万', '100万-500万', '500万-1000万', '1000万-5000万', '5000万-1亿', '1亿以上'],
  // 员工人数：
  yuangongrenshu: ['10人以下', '10-50人', '50-100人', '100-500人', '500-1000人', '1000-5000人', '5000-1万人', '1万以上'],
  // 岗位类别：
  gangweilb: ['管理类', '技术类', '财经类', '行政类', '服务类', '营销类', '普工类', '教育类', '医务类', '金融类', '中介类', '建筑类', '法律类', '其它类'],
  // 待遇水平：
  daiyushuiping: ['3001-4000', '4001-5000', '5001-6000', '6000以上', '其它'],
  // 职位类别：
  zhiweileibie: ['不限', '全职', '兼职', '实习', '临时', '钟点'],
  // 工作年限：
  gongzuonianxian: ['1年以下', '1-3年', '3-10年', '10年以上'],
  // 学历
  dwzp_xl: ['中专', '大专', '本科', '硕士', '博士', '高中', '其它'],
  // 就业群体
  gongzuoqunti: ['贫困人员', '高校毕业生', '退役军人', '残疾人', '退捕渔民', '其它失业人员'],
  // 工作地区
  gongzuodiqu: ['县内', '县外省内', '珠三角', '长三角', '京津冀', '境外', '其它'],
  laoWuXieZuoFS: [
    { label: '省际间', value: '0' },
    { label: '省内', value: '1' },
  ],
  // 数据来源 
  shujulaiyuan: [
    { label: '就业扶贫车间', value: '0' },
    { label: '以工代训补贴', value: '1' },
  ],
  canJiaPeiXunQK: [
    { label: '参加过培训', value: '0' },
    { label: '未参加过培训', value: '1' },
  ],
  youZuZhiLaoWuSC: [
    { label: '统一包租车输出', value: '0' },
    { label: '免费专场招聘会', value: '1' },
    { label: '就业扶贫基地吸纳', value: '1' },
  ],
  // 致贫原因
  checkList2: [
    { label: '因病', value: '0' },
    { label: '因灾', value: '1' },
    { label: '因残', value: '2' },
    { label: '因学', value: '3' },
    { label: '缺土地', value: '4' },
    { label: '缺水', value: '5' },
    { label: '缺技术', value: '1' },
    { label: '缺资金', value: '1' },
    { label: '缺劳动力', value: '1' },
    { label: '缺交通条件', value: '1' },
    { label: '自身发展动力不足', value: '1' },
  ],
  // 脱贫方式
  checkList3: [
    { label: '就业脱贫', value: '0' },
    { label: '发展生产脱贫', value: '1' },
    { label: '易地扶贫搬迁脱贫', value: '2' },
    { label: '生态补偿脱贫', value: '3' },
    { label: '发展教育脱贫', value: '4' },
    { label: '社会保障兜底脱贫', value: '5' },
    { label: '医疗帮扶', value: '1' },
  ],
  // 健康状况
  jiankangzhuangtai: ['健康', '长期慢性病', '患有大病', '残疾', '长期慢性病,残疾', '患有大病,残疾', '长期慢性病,患有大病,残疾'],
  // 抽查结果
  chouchajieguo: [
    { label: '信息相符', value: '1' },
    { label: '岗位信息错误', value: '2' },
    { label: '岗位已招满', value: '3' },
    { label: '企业无此岗位', value: '4' },
    { label: '停机', value: '5' },
    { label: '空号', value: '6' },
    { label: '关机', value: '7' },
    { label: '无人应答', value: '8' },
    { label: '不配合调查', value: '9' },
    { label: '其它', value: '0' },
  ],
  // 岗位状态 + 拟招聘状态
  gangweizhuangtai: [
    { label: '有效', value: '1' },
    { label: '无效', value: '2' },
    { label: '数据不完整', value: '3' },
  ],
  // 所属部门
  suoshubumen: [
    { label: '林业部门', value: '1' },
    { label: '住建部门', value: '1' },
    { label: '交通部门', value: '1' },
    { label: '水利部门', value: '1' },
    { label: '人社部门', value: '1' },
    { label: '其它部门', value: '1' },
  ],
  // 务工状况
  wugongzhuangkuang: [
    { label: '省外务工', value: '1' },
    { label: '县外省内务工', value: '2' },
    { label: '乡(镇)外县内务工', value: '3' },
    { label: '乡(镇)内务工', value: '4' },
  ],
  // 在岗状态
  zaigangzhuangtai: [
    { label: '在岗', value: '1' },
    { label: '退岗', value: '1' },
  ],
  // 脱贫状态
  tuopinzhuangtai: [
    { label: '已脱贫', value: '1' },
    { label: '未脱贫', value: '1' },
  ],
  // 补贴类型
  butieleixing: [
    { label: '农村劳务经纪人', value: '1' },
    { label: '非农村劳务经纪人', value: '1' },
  ],
  // 专岗类型
  zhuangangleixing: [
    { label: '无限制', value: '1' },
    { label: '大学生专岗', value: '1' },
  ],
  // 申报状态
  shengbaozhuangtai: [
    { label: '审核完成', value: '1' },
    { label: '未审核', value: '1' },
  ],
  // 就业状态
  jiuyezhuangtai: [
    { label: '未就业', value: '1' },
    { label: '已就业', value: '1' },
  ],
  // 贫困户属性
  pinkunhushuxing: [
    { label: '低保户', value: '1' },
    { label: '低保贫困户', value: '1' },
    { label: '特困供养户', value: '1' },
    { label: '特困供养贫困户', value: '1' },
    { label: '一般农户', value: '1' },
    { label: '一般贫困户', value: '1' },
  ],
  // 在校生状况
  zaixiaoshengzhuangkuang: [
    '学龄前儿童',
    '学前教育',
    '小学',
    '七年级',
    '八年级',
    '九年级',
    '普通高中一年级',
    '普通高中二年级',
    '普通高中三年级',
    '技师学院一年级',
    '技师学院二年级',
    '技师学院三年级',
    '中职一年级',
    '中职二年级',
    '中职三年级',
    '高职高专一年级',
    '高职高专二年级',
    '高职高专三年级',
    '本科一年级',
    '本科二年级',
    '本科三年级',
    '本科四年级',
  ],
  // 工作类型
  gongzuoleixing: ['非专职', '专职'],
  // 政治面貌
  zhengzhimianmao: [
    { label: '群众', value: '1' },
    { label: '共青团员', value: '1' },
    { label: '党员', value: '1' },
  ],
  // 户藉类型
  hujileixing: [
    { label: '农业', value: '1' },
    { label: '农转非', value: '1' },
    { label: '城市', value: '1' },
  ],
  // 单位性质
  danweixingzhi: [
    { label: '企业单位', value: '1' },
    { label: '事业单位', value: '1' },
    { label: '国家行政机关', value: '1' },
  ],
  // 人员类型
  renyuanleixing: [
    { label: '新增就业', value: '1' },
    { label: '已转移就业', value: '1' },
    { label: '未就业有就业意愿', value: '1' },
    { label: '未转移就业', value: '1' },
    { label: '有培训意愿', value: '1' },
    { label: '有政策经办', value: '1' },
  ],
  // 单位级别 + 单位属性
  danweijibie: [
    { label: '省级', value: '0' },
    { label: '市级', value: '0' },
    { label: '县级及以下', value: '0' },
  ],
  //日志数据
  info: [
    { key: 'province', value: '省' },
    { key: 'city', value: '市' },
    { key: 'county', value: '县' },
    { key: 'town', value: '镇' },
    { key: 'village', value: '村' },
    { value: '操作日志类型', key: 'operateLogType' },
    { value: '帮扶内容', key: 'serviceContent' },
    { value: '帮扶结果', key: 'serviceResult' },
    { value: '帮扶责任人', key: 'helpName' },
    { value: '电话号码', key: 'helpPhone' },
    { value: '目标姓名', key: 'targetName' },
    { value: '目标电话', key: 'targetPhone' },
    { value: '操作时间', key: 'time' },
  ],
  type: ['结对帮扶', '信息采集', '就业服务', '培训服务', '创业服务', '维权服务', '其它服务', '我的日志'],
  //上传地址
  upload_url: {
    _a: `${ip}/user/socialAllowance/import`, // 岗位、社保补贴统计表--导入
    _b: `${ip}/user/loveUnit/import`,//导入爱心单位
    _c: `${ip}/user/onceSetupAllowance/import`, //一次性求职创业补贴统计表--导入
    _d: `${ip}/user/publicWelfareJob/import`,  // 公益性岗位安置统计表--导入
    _e: `${ip}/user/jobUpdate/import`, // 导入岗位信息更新
    _f: `${ip}/user/employmentBase/import`, //导入就业扶贫基地
    _g: `${ip}/user/jobCheck/import`, //导入岗位抽查	
    _h: `${ip}/user/personCheck/import`, //导入人员抽查
    _i: `${ip}/user/poorLabor/import`, //导入贫困劳动力抽查
    _j: `${ip}/user/helpPoorWorkshop/import`, //导入就业扶贫车间表
    _k: `${ip}/user/mineOrg/import`, //导入独立工矿表
    _l: `${ip}/user/helpCP/import`, //导入贵阳县结对帮扶总表
    _m: `${ip}/user/retireSoldier/import`, //导入退役军人月报
    _n: `${ip}/user/trainingWorkAllowance/import`, //导入以工代训补贴统计表
    _o: `${ip}/user/trafficAllowance/import`, //导入交通补贴统计表
    _p: `${ip}/user/trainingAllowance/import`, //导入岗位补贴和生活费补贴统计表
    _q: `${ip}/user/villageAgent/import`, //导入农村劳务经纪人统计表
    _r: `${ip}/user/villageAgentApplyAllowance/import`, //导入农村劳务经纪人补贴申报统计表
    _s: `${ip}/user/resourceOrganization/import`, //导入人力资源机构统计表
    _t: `${ip}/user/pioneerJobAllowance/import`, //导入人力资源机构补贴申报统计表
    _u: `${ip}/user/lostJobPerson/import`, //导入城镇失业人员统计表
    _v: `${ip}/user/targetTask/import`, //导入目标任务统计表
    _w: `${ip}/user/resourceMarket/import`, //导入人力资源市场主要统计表
    _x: `${ip}/user/transferJob/import`, //导入劳动力转移就业和创业表
    _y: `${ip}/user/recruitUnit/import`, //导入单位招聘统计表
    _z: `${ip}/user/poorInfo/import`, //导入一户一档信息表
    _aa: `${ip}/user/bobaiHelpPoorWorkShop/import`, //导入博白县的就业扶贫车间
    _bb: `${ip}/user/bobaiPoorlabor/import`, //导入博白县名册汇总
    _cc: `${ip}/user/bobaiTransfer/import`, //导入--博白县就业扶贫车间吸纳建档立卡贫困家庭劳动力就业花名册(易地扶贫搬迁)
    _dd: `${ip}/user/bobaiPoorRecord/import`, //导入--博白县就业扶贫车间吸纳建档立卡贫困家庭劳动力就业情况动态监管台账
    _ee: `${ip}/user/bobaiHelpPoorManage/import`, //博白县就业扶贫车间动态管理台帐
  },
  //权限表
  // powerList: [
  //   { id: 'hn-poor-labor', label: '个人信息采集管理' },
  //   { id: 'hn-job-update', label: '用工信息采集管理' },
  //   { id: 'hn-loveUnit', label: '爱心单位采集管理' },
  //   { id: 'hn-cp', label: '扶贫结对帮扶管理' },
  //   { id: 'hn-base', label: '就业扶贫基地管理' },
  //   { id: 'hn-poor-info', label: '一户一档信息管理' },
  //   { id: 'hn-mine-org', label: '独立工矿报表管理' },
  //   { id: 'hn-retire-soldier', label: '退役军人月报管理' },
  //   { id: 'hn-labor-transfer', label: '农村劳动力转移就业和创业情况表' },
  //   { id: 'hn-training-work', label: '以工代训补贴统计表', },
  //   { id: 'hn-once-setup', label: '一次性求职创业补贴统计表' },
  //   { id: 'hn-traffic-allowance', label: '交通补贴统计表' },
  //   { id: 'hn-social-allowance', label: '岗位、社保补贴统计表' },
  //   { id: 'hn-training', label: '培训补贴和生活费补贴' },
  //   { id: 'hn-allowance-report', label: '补贴情况总统计表' },
  //   { id: 'hn-public-welfare-job', label: '公益性岗位安置统计表' },
  //   { id: 'hn-help-poor-work-shop', label: '就业扶贫车间统计表' },
  //   { id: 'hn-person-check', label: '人员抽查统计表' },
  //   { id: 'hn-resource-report', label: '人力资源市场主要统计表' },
  //   { id: 'hn-village-age', label: '农村劳务经纪人统计表' },
  //   { id: 'hn-village-age-allowance', label: '农村劳务经纪人补贴申报统计表' },
  //   { id: 'hn-resource_organization', label: '人力资源服务机构统计表' },
  //   { id: 'hn-resource_organization-allowance', label: '人力资源服务机构补贴申报统计' },
  //   { id: 'hn-job-check', label: '岗位抽查统计表' },
  //   { id: 'hn-pioneer-allowance', label: '就业创业服务补贴统计表(导出)' },
  //   { id: 'hn-recruit-unit', label: '单位招聘统计表' },
  //   { id: 'hn-target-task', label: '目标任务表' },
  //   { id: 'hn-lost-job-person', label: '城镇失业人员统计表' },
  //   { id: 'hn-service-log', label: '结对帮扶管理' },
  //   { id: 'hn-service-log', label: '信息采集管理' },
  //   { id: 'hn-service-log', label: '就业服务管理' },
  //   { id: 'hn-service-log', label: '培训服务管理' },
  //   { id: 'hn-service-log', label: '创业服务管理' },
  //   { id: 'hn-service-log', label: '其它服务管理' },
  //   { id: 'hn-service-log', label: '维权服务管理' },
  //   { id: 'bb-help-poor-work-shop', label: '就业扶贫车间基本情况汇总表' },
  //   { id: 'bb-poor-labor', label: '就业扶贫车间吸纳就业名册汇总表' },
  //   { id: 'bb-poor-record', label: '就业扶贫车间动态管理台帐' },
  //   { id: 'bb-transfer', label: '吸纳贫困劳动力就业动态监管台账' },
  //   { id: 'bb-work-shop-manage', label: '吸纳易地变迁贫困劳动力就业名册' },
  //   { id: 'law-service-audit', label: '法律审核' },
  //   { id: 'training-apply', label: '培训审核' },
  //   { id: 'training-apply', label: '培训上传' },
  //   { id: 'user-info-check', label: '个人信息审核' },
  //   { id: 'hn-job-update-data-export', label: '岗位更新数据导出' },
  // ],
  map_Navigation: [
    {
      name: '登录',
      path: 'www.baidu.aom',
      type: 1,
      show: true
    },
    {
      name: 'PC端下载',
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
      type: 0,
      show: false
    },
    {
      name: 'APP下载',
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
      type: 0,
      show: false
    },
    {
      name: '小程序',
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
      type: 0,
      show: false
    },
    {
      name: '公众号',
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
      type: 0,
      show: false
    },
    {
      name: '微博',
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
      type: 0,
      show: false
    },
    {
      name: '帮助中心',
      path: '',
      type: 1,
      show: true
    },
  ],
  map_menu: [
    {
      type: 1,
      data: {},
      name: '首页',
      show: true,
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
    },
    {
      type: 1,
      data: {},
      name: '数据分析',
      show: true,
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
    },
    {
      type: 1,
      data: {},
      name: '系统管理',
      show: true,
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
    },
    {
      type: 0,
      data: [
        {
          name: '招聘',
          url: ''
        },
        {
          name: '求职',
          url: ''
        }
      ],
      name: '就业视吧',
      show: false
    },
    {
      type: 0,
      data: [
        {
          name: '教育',
          url: ''
        },
        {
          name: '培训',
          url: ''
        }
      ],
      name: '在线培训',
      show: false
    },
    {
      type: 0,
      data: [
        {
          name: '招商',
          url: ''
        },
        {
          name: '加盟',
          url: ''
        },
        {
          name: '融资',
          url: ''
        },
        {
          name: '投资',
          url: ''
        }
      ],
      name: '创新创业',
      show: false
    },
    {
      type: 0,
      data: [
        {
          name: '求助',
          url: ''
        },
        {
          name: '民事',
          url: ''
        },
        {
          name: '刑事',
          url: ''
        },
        {
          name: '行政',
          url: ''
        }
      ],
      name: '法律维权',
      show: false
    },
    {
      type: 1,
      data: [],
      name: '人事人才',
      show: true,
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
    },
    {
      type: 0,
      data: [
        {
          name: '旅游',
          url: ''
        },
        {
          name: '美食',
          url: ''
        },
        {
          name: '健康',
          url: ''
        },
        {
          name: '电商',
          url: ''
        }
      ],
      name: '乡村振兴',
      show: false
    },
    {
      type: 1,
      data: [],
      name: 'OA系统',
      show: true,
      path: 'http://bbswater-fd.zol-img.com.cn/t_s800x5000/g5/M00/07/09/ChMkJ1Z4F52IAW42AACeE47phQQAAGdjwNjXxEAAJ4r204.png',
    }
  ],
  proportion_data: [
    {
      name: '贫困劳动力',
      color: '#477bd8',
      proportion: 0,
    },
    {
      name: '已就业人员',
      color: '#6ec245',
      proportion: 0,
    },
    {
      name: '未就业人员(无就业意愿)',
      color: '#ddd05e',
      proportion: 0,
    },
    {
      name: '未就业人员(有就业意向)',
      color: '#ca5857',
      proportion: 0,
    },
  ],
  color_code: [
    {
      name: '一级',
      color: '#ca5857',
    },
    {
      name: '二级',
      color: '#ddd05e',
    },
    {
      name: '三级',
      color: '#6ec245',
    },
  ],
  swiper_data: [
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 0,
      photo: 'http://img0.imgtn.bdimg.com/it/u=381806366,2864877724&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img0.imgtn.bdimg.com/it/u=2557360828,1026767012&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 1,
      photo: 'http://img1.imgtn.bdimg.com/it/u=3650106465,2941829864&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 0,
      photo: 'http://img2.imgtn.bdimg.com/it/u=4038161296,2529355076&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img0.imgtn.bdimg.com/it/u=3166831852,3686564622&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 1,
      photo: 'http://img4.imgtn.bdimg.com/it/u=333805708,914523234&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img2.imgtn.bdimg.com/it/u=2783924764,941026102&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 1,
      photo: 'http://img2.imgtn.bdimg.com/it/u=4038161296,2529355076&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img0.imgtn.bdimg.com/it/u=3166831852,3686564622&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 0,
      photo: 'http://img4.imgtn.bdimg.com/it/u=333805708,914523234&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img2.imgtn.bdimg.com/it/u=2783924764,941026102&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 1,
      photo: 'http://img2.imgtn.bdimg.com/it/u=4038161296,2529355076&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 2,
      photo: 'http://img0.imgtn.bdimg.com/it/u=3166831852,3686564622&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 1,
      photo: 'http://img4.imgtn.bdimg.com/it/u=333805708,914523234&fm=26&gp=0.jpg'
    },
    {
      name: '水哥',
      phone: '136-7838-0508',
      card: '62112119920404',
      type: 0,
      photo: 'http://img2.imgtn.bdimg.com/it/u=2783924764,941026102&fm=26&gp=0.jpg'
    }
  ],

  //博白县数据
  //劳动力情况
  laodongli: ['普通劳动力', '丧失劳动力', '无劳动力', '弱劳动力或半劳动力'],
  //扶贫车间类型
  chejianleixing: ['工厂式', '种养式', '居家式', '种植型', '居家型'],


  //诉讼类型
  laytype:[
    {label:'劳动维权',value:'1'},
    {label:'民事诉讼',value:'2'},
    {label:'刑事诉讼',value:'3'},
    {label:'行政诉讼',value:'4'},
  ],


  // 招生性质
  hireProperty:[
    {label:'不限',value:'不限'},
    {label:'全日制',value:'全日制'},
    {label:'电大',value:'电大'},
    {label:'成教',value:'成教'},
    {label:'函授',value:'函授'},
    {label:'网络教育',value:'网络教育'},
    {label:'自考',value:'自考'},
    {label:'其它',value:'其它'},
  ],
  // 招生状态
  hireStatus:['未招满','已招满'],
  // 招生班次
  hireClass:['不限','白班','晚班','周末班','其它'],
  // 教育毕业学历
  educationBackGround:['不限','高中','中专','大专','本科','硕士','博士','其它'],


  // 薪资水平 =>对于职位发布者而言,薪资没有'不限'的选项
  gongzishuiping:['面议','3K以下','3K-8K','8K-15K','15K以上'],
  // 期望薪资 =>用作筛选,求职者可以选择'不限'
  qiwangxinzi:['不限','面议','3K以下','3K-8K','8K-15K','15K以上'],
  // 职位类别
  zhiweitype:['不限','管理类', '技术类', '财经类', '行政类', '服务类', '营销类', '普工类', '教育类', '医务类', '金融类', '中介类', '建筑类', '法律类', '其它类'],
  // 招聘部门
  zhaopinbumen:['人事部','市场部','研发部','公关部','财务部','法务部','其它'],
  //工作经验
  workexperience:['不限','1年以下','1-3年','3-5年','5年以上'],
  //年龄
  age:['不限','30岁以下','30-40岁','40-50岁','50岁以上'],
  //能力
  ability:['优','良','一般','较差'],
  //婚否
  ismarriage:['已婚','未婚'],
  //项目状态
  xiangmustatus:['不限','种子期','初创期','发展期','扩展期','成熟期','其它'],
  //投资方式
  touzifangshi:['不限','股权投资','债权投资','天使投资','风险投资','产业投资','其它'],
  //招商状态
  attractInvestmentStatus:['正在招商','停止招商'],
  //加盟状态
  jiamengStatus:['正在加盟','停止加盟'],
  //融资状态
  rongziStatus:['正在融资','停止融资'],
  //投资状态
  touziStatus:["正在投资","停止投资"],
  // 租房类型
  housetype:['不限','单间','套一','套二','套三','别墅','商务楼','其它'],
  // 装修情况
  renovation:['不限','简装','精装','一般','清水房','其它'],
  // 租金分层
  rentcash:['不限','≤1000元','1000-1500元','1500-2000元','2000-2500元','2500-3000元','3000-5000元','≥5000元'],
  // 租房状态
  renthousestatus:['未出租','已出租'],
  // 租房进展
  renttime:['正在出租','出租完毕'],
  //房屋朝向
  direct:['正北','东北','正东','东南','正南','西南','正西','西北',],
  //售房状态
  saleHouseStatus:['出售','未出售'],
  //售房进展
  progressStatus:['未卖房','正在卖房','已卖房'],
  //付款方式
  fukuanfangshiMapList: ['一次性','银行按揭'],
  //汽车类型
  carType:['两厢','三厢','商务','越野','货车','客车','其它',],
  // 汽车进展状态
  carStatus:['未卖车','正在卖车','已卖车'],
  // 服务
  fuwu:['招聘','求职','律师','教育','培训','融资','投资','招商','加盟','租房','售房','汽车','交友','电商','美食','旅游','健康'],
  fuwumap: {
    '招聘': 'zhaopin',
    '求职': 'qiuzhi',
    '律师': 'lvshi',
    '教育': 'jiaoyu',
    '培训': 'peixun',
    '融资': 'rongzi',
    '投资': 'touzi',
    '招商': 'zhaoshang',
    '加盟': 'jiameng',
    '租房': 'zufang',
    '售房': 'shoufang',
    '汽车': 'qiche',
    '交友': 'jiaoyou',
    '电商': 'gouwu',
    '美食': 'meishi',
    '旅游': 'lvyou',
    '健康': 'jiankang',
  },
  //星期
  week:['天','一','二','三','四','五','六'],
  // 商品类别   电商
  catalog:[
    '保健品',
    '护具',
    '食品',
    '礼品',
    '工艺品',
    '装饰品',
    '日用品',
    '生鲜',
    '宠物用品',
    '宠物食品',
    '服饰',
    '厨具',
    '刀具',
    '餐具',
    '家具',
    '数码',
    '配饰',
    '家纺',
    '乐器',
    '玩具'
  ],
}

export const publicData2 = {
  nation: [
    '汉族',
    '蒙古族',
    '回族',
    '藏族',
    '维吾尔族',
    '苗族',
    '彝族',
    '壮族',
    '布依族',
    '朝鲜族',
    '满族',
    '侗族',
    '瑶族',
    '白族',
    '土家族',
    '哈尼族',
    '哈萨克族',
    '傣族',
    '黎族',
    '傈傈族',
    '佤族',
    '畲族',
    '高山族',
    '拉祜族',
    '水族',
    '东乡族',
    '纳西族',
    '景颇族',
    '柯尔克孜族',
    '土族',
    '达翰尔族',
    '仫佬族',
    '羌族',
    '布朗族',
    '撒拉族',
    '毛南族',
    '仡佬族',
    '锡伯族',
    '阿昌族',
    '普米族',
    '塔吉克族',
    '怒族',
    '乌孜别克族',
    '俄罗斯族',
    '鄂温克族',
    '德昂族',
    '保安族',
    '裕固族',
    '京族',
    '塔塔尔族',
    '独龙族',
    '鄂伦春族',
    '赫哲族',
    '门巴族',
    '珞巴族',
    '基诺族',
    '其它',
  ]
}